import { render, staticRenderFns } from "./FreeTransform.vue?vue&type=template&id=7f510dfe&"
import script from "./FreeTransform.vue?vue&type=script&lang=js&"
export * from "./FreeTransform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FreeTransform.vue"
export default component.exports